import { useApiUrl } from '@refinedev/core';
import { useQuery } from '@tanstack/react-query';

import { ProjectTemplateTest } from '../types';
import httpClient from '../utils/axios';

/**
 * Given a testId will fetch scenarios information.
 *
 * The key stays `['testScenarios', testId]` rather than moving to the request URL: the URL is built
 * from Refine's `useApiUrl()` at render time, and the only other toucher of this key is
 * `ScenarioDraggableItem`, which invalidates the same tuple. There is no `packages/queries` twin to
 * align a URL-shaped key with — this app resolves its own data through Refine.
 */
const useDetailedProjectTemplateTest = (testId: string) => {
  const apiUrl = useApiUrl();

  return useQuery({
    queryKey: ['testScenarios', testId] as const,
    queryFn: async ({ signal }) => {
      const { data } = await httpClient.get<ProjectTemplateTest>(
        `${apiUrl}/assessment_template_tests/${testId}?detailed=True&ordering=order`,
        { signal }
      );

      return data;
    },
    refetchOnWindowFocus: false
  });
};

export default useDetailedProjectTemplateTest;
